import { useContext } from 'react';
import { GitHubAuthContext, GitHubAuthContextType } from '../contexts/GitHubAuthContextType';

export const useGitHubAuth = (): GitHubAuthContextType => {
  const context = useContext(GitHubAuthContext);
  if (context === undefined) {
    throw new Error('useGitHubAuth must be used within a GitHubAuthProvider');
  }
  return context;
};
